<nz-layout>
  <nz-content>
    @if (activeCategoryModule; as cm) {
      @if (cm.path === componentPaths.velesQuestionnaires) {
        <app-veles-questionnaire
          [id]="cm.path"
          [modules]="cm.childModules"
          [(selectedOption)]="selectedOption"
          [readonlyMode]="readonlyMode"
          [overviewItemsByTemplateId]="overviewItemsByTemplateId"
          [overviewLoading]="isOverviewLoading"
          [overviewError]="overviewError"
          (overviewRefreshRequested)="handleOverviewRefreshRequested()"
        />
      }
    }
  </nz-content>
</nz-layout>